import React, { useState } from 'react';
import { Box, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import GraphCard from './GraphCard';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles((theme) => ({
  carouselContainer: {
    width: '100%',
    padding: '0 50px',
  },
  carouselContent: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
    gap: '20px',
    justifyContent: 'center',
  },
  navButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    color: 'white',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
    },
  }
}));

const Carousel = ({ graphData, targets, updateTarget, onAnalyze }) => {
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(0);
  const cardsPerPage = 6;

  const nextPage = () => {
    setCurrentPage((prev) => (prev + 1) % Math.ceil(graphData.length / cardsPerPage));
  };

  const prevPage = () => {
    setCurrentPage((prev) => (prev - 1 + Math.ceil(graphData.length / cardsPerPage)) % Math.ceil(graphData.length / cardsPerPage));
  };

  const currentCards = graphData.slice(currentPage * cardsPerPage, (currentPage + 1) * cardsPerPage);

  return (
    <Box className={classes.carouselContainer}>
      <IconButton onClick={prevPage} className={classes.navButton} style={{ left: 10 }}>
        <ChevronLeftIcon />
      </IconButton>
      <Box className={classes.carouselContent}>
        {currentCards.map((data, index) => (
          <GraphCard 
            key={index} 
            data={data}
            target={targets[index] || 0}
            updateTarget={(newValue) => updateTarget(index, newValue)}
            onAnalyze={onAnalyze} 
          />
        ))}
      </Box>
      <IconButton onClick={nextPage} className={classes.navButton} style={{ right: 10 }}>
        <ChevronRightIcon />
      </IconButton>
    </Box>
  );
};

export default Carousel;